/** Used to represent a null ticket template for dropdowns */
export const NULL_TICKET_TEMPLATE = {
  id: null,
  name: '<None>',
  type: ''
};
export type NullTicketTemplate = typeof NULL_TICKET_TEMPLATE;
